export default [
    {
        path: '/orders',
        name: 'LeadIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Leads',
            fullHeight: true,
        },
        components: {
            default: () => import('@views/leads/LeadsIndex.vue'),
        },
    },
    {
        path: '/orders/create',
        name: 'LeadCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create lead',
        },
        components: {
            default: () => import('@views/leads/LeadCreate.vue'),
        },
    },
    {
        path: '/orders/:id/view',
        name: 'OrderView',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Order',
        },
        beforeEnter: async (to, from, next) => {
            const id = to.params.id;
            // Check if ID is valid - not undefined, null, "undefined", or non-numeric
            if (!id || id === 'undefined' || id === 'null' || isNaN(Number(id)) || Number(id) <= 0) {
                next({ name: 'OrderNotFound' });
            } else {
                if (to.query.bypassChecklist) {
                    next();
                    return;
                }

                const userStore = useUserStore();

                if (userStore.isOnlyFieldStaff()) {
                    const { data: resp } = await window.tenantAxios.get(`/orders/${id}/pre-job-checklist`);
                    if (resp.is_each_form_filled) {
                        next();
                        return;
                    }
                    next({ name: 'OrderPreJobChecklist', params: { id, formData: resp } });
                } else {
                    next();
                }
            }
        },
        props: {
            default: (route) => ({ id: route.params.id, bypassChecklist: route.params.bypassChecklist ?? false }),
        },
        components: {
            default: () => import('@views/orders/Order.vue'),
        },
    },
    {
        path: '/orders/:id/inventory',
        name: 'OrderInventory',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Inventory',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/OrderInventory.vue'),
        },
    },
    {
        path: '/orders/:id/inventory/condition-report',
        name: 'OrderInventoryConditionReport',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Inventory condition report',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/OrderInventoryConditionReport.vue'),
        },
    },
    {
        path: '/orders/:id/inventory/condition-report/sign-off',
        name: 'IcrSignOff',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'ICR sign off',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/IcrSignOff.vue'),
        },
    },
    {
        path: '/orders/:id/inventory/condition-report/view-signed-off',
        name: 'IcrViewSignedOff',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'View signed off',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/IcrViewSignedOff.vue'),
        },
    },
    {
        path: '/orders/:id/pre-job-checklist',
        name: 'OrderPreJobChecklist',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Pre-job checklist',
        },
        props: {
            default: (route) => ({ id: route.params.id, formData: route.params.formData }),
        },
        components: {
            default: () => import('@views/orders/OrderPreJobChecklist.vue'),
        },
    },
];
